// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SimpleCard_wrapper__36t67"};